import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { PageResponse, Pagination } from '@core/shared/domain';
import { NotificationService } from '@core/shared/util';
import { ArticleSearchRequest, SearchArticle } from '@mp/content-manager/artikelsuche/data-access';

import { FavoritesService } from './favorites.service';

@Injectable()
export class FavoriteListArticlesFacade {
  constructor(
    private readonly favoritesService: FavoritesService,
    private readonly notificationService: NotificationService,
  ) {}

  fetchFavoriteListArticles(id: string, pagination?: Pagination): Observable<PageResponse<SearchArticle>> {
    return this.favoritesService.getAllArticles(id, pagination);
  }

  addArticleToList(listId: string, articles: string[]): Observable<unknown> {
    return this.favoritesService
      .addArticleToList(listId, articles)
      .pipe(tap(() => this.notificationService.toastSuccess('Der Artikel wurde zu der Liste hinzugefügt.')));
  }

  addAllArticlesToList(listId: string, request: ArticleSearchRequest): Observable<unknown> {
    return this.favoritesService
      .addAllArticlesToList(listId, request)
      .pipe(
        tap(() => this.notificationService.toastSuccess('Die ausgewählten Artikel wurden zu der Liste hinzugefügt.')),
      );
  }

  removeArticleFromList(listId: string, globalArticleId: string): Observable<void> {
    return this.favoritesService
      .removeArticleFromList(listId, globalArticleId)
      .pipe(tap(() => this.notificationService.toastSuccess('Der Artikel wurde aus den Favoriten entfernt.')));
  }
}
